import * as React from 'react'

export default () => (
  <div className="has-text-right  is-size-7">
    <a href="#top">↑ Back to top</a>
  </div>
)
